module.exports = __webpack_public_path__ + "img/hero-upgrade.64aaa60b.png";